module.exports = __webpack_public_path__ + "media/brands/brandHeader-abc5691c.jpg";